import {Component, OnInit, Output, EventEmitter, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@core/translate';
import { AuthService } from '@core/auth/auth.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
//import { LoggerService } from '@wdpr/ra-angular-logger';
import { BASE_API_URL } from './config/app.config';
import { KngActivityIndicatorService } from '@layout/kingswell/services/kngActivityIndicator.service';
import {MainKngContentScrollEvent} from "@events/MainKngContentScrollEvent";
import {CannotGetAuthTokenEvent} from "@events/CannotGetAuthTokenEvent";
import {Subscription} from "rxjs/Subscription";
import {UnauthorizedAPIEvent} from "@events/UnauthorizedAPIEvent";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = "D Clean Admin";

  cannotGetAuthTokenSubscription: Subscription;
  unauthorizedAPISubscription: Subscription;

  @Output() update = new EventEmitter<any>();
  constructor(/*private _logger: LoggerService*/private _translate: TranslateService, private _auth: AuthService, private _router: Router, private _http: HttpClient, private kngActivityIndicator: KngActivityIndicatorService, private router: Router
              , private mainKngContentScrollEvent : MainKngContentScrollEvent
              , private cannotGetAuthTokenEvent: CannotGetAuthTokenEvent, private unauthorizedAPIEvent: UnauthorizedAPIEvent) {
    //this._logger.error('logger message', 'other param');
    //this._logger.debug('this is a test debug message');

    if( !this.isLoggedIn() ){
      this._router.navigate(['login']);
    }

    this.cannotGetAuthTokenSubscription = this.cannotGetAuthTokenEvent.on()
      .subscribe(()=>{
        console.log("Cannot get Auth Token,  will redirect to login");
        this._router.navigate(['login']);
      });

    this.unauthorizedAPISubscription = this.unauthorizedAPIEvent.on()
      .subscribe(() => {
        console.log("unauthorizedAPIEvent called!!!");
        this._auth.logout();
        this._router.navigate(['unauthorizedAccess']);
      });
  }

  ngOnInit() {
    // Initialize translations
    this._translate.use('en');
  }

  ngOnDestroy() {
    if( this.cannotGetAuthTokenSubscription ){
      this.cannotGetAuthTokenSubscription.unsubscribe();
    }

    if( this.unauthorizedAPISubscription ){
      this.unauthorizedAPISubscription.unsubscribe();
    }
  }

  openProfile() {
    this.update.emit('kng-profile.open');
  }

  onScroll(topScroll){
    this.mainKngContentScrollEvent.broadcast(topScroll);
  }

  isLoggedIn(){
    return this._auth.isLoggedIn();
  }

  isAdmin(){
    return this._auth.isAdmin();
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/app.component.ts